
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/global-views",
      function () {
        return require("private-next-pages/case-study/global-views.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/global-views"])
      });
    }
  